import { HttpClient, HttpErrorResponse, HttpStatusCode } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';

import { Observable, catchError, of, throwError } from 'rxjs';

import { PROTECTED_API_URL } from '@lib/core/tokens/api.tokens';

import { ActiveCoverage } from '../models/active-coverage.model';
import { Package } from '../models/package-configurator/package.model';

@Injectable({
  providedIn: 'root',
})
export class ActiveCoverageService {
  private readonly http = inject(HttpClient);
  private readonly apiUrl = inject(PROTECTED_API_URL);

  getUserPackage(userId: string): Observable<Package | null> {
    return this.http.get<Package>(`${this.apiUrl}/v2/packages/by-user/${userId}/package`).pipe(catchError(nullWhenMissing));
  }

  getActiveCoverage(packageId: string): Observable<ActiveCoverage | null> {
    return this.http.get<ActiveCoverage>(`${this.apiUrl}/v2/packages/${packageId}/active-coverage`).pipe(catchError(nullWhenMissing));
  }

  getOptionDiagnoses(coverageId: string, optionId: string): Observable<string[]> {
    return this.http.get<string[]>(`${this.apiUrl}/v2/coverages/${coverageId}/options/${optionId}/diagnoses`);
  }
}

function nullWhenMissing(error: HttpErrorResponse): Observable<null> {
  const missing = error.status === HttpStatusCode.NotFound || error.status === HttpStatusCode.BadRequest;
  return missing ? of(null) : throwError(() => error);
}
